import React from 'react';
import ImagePlaceholder from './ImagePlaceholder';
import useFadeIn from './useFadeIn';

/*
  GALERIA — jak podmienić zdjęcia:
  Umieść pliki w /public/images/ (nazwy w tablicy images poniżej).
  Zamień każdy <ImagePlaceholder> na:
  <img src={`/images/${item.file}`} alt={item.label}
       style={{ width:'100%', display:'block', transition:'transform 0.6s ease' }} />
*/

const images = [
  { label: 'Infiniti FX35 – przód', file: 'gallery-front.jpg', ratio: '4/3' },
  { label: 'Infiniti FX35 – tył', file: 'gallery-rear.jpg', ratio: '4/3' },
  { label: 'Wnętrze – kokpit', file: 'gallery-cockpit.jpg', ratio: '3/4' },
  { label: 'Tylna kanapa', file: 'gallery-backseat.jpg', ratio: '4/3' },
  { label: 'Detale – felga', file: 'gallery-wheel.jpg', ratio: '1/1' },
  { label: 'Infiniti FX35 – profil', file: 'gallery-side.jpg', ratio: '16/9' },
  { label: 'Detale – logo', file: 'gallery-logo.jpg', ratio: '1/1' },
  { label: 'Wnętrze – deska rozdzielcza', file: 'gallery-dash.jpg', ratio: '4/3' },
];

export default function Gallery() {
  const titleRef = useFadeIn();

  return (
    <section
      id="gallery"
      style={{
        padding: '120px 24px',
        background: 'linear-gradient(180deg, #0a1628 0%, #050a1a 100%)',
        position: 'relative',
      }}
    >
      <div style={{ maxWidth: 1280, margin: '0 auto' }}>
        <div ref={titleRef} className="fade-in-section" style={{ textAlign: 'center', marginBottom: 64 }}>
          <p className="section-label" style={{ marginBottom: 16 }}>Galeria</p>
          <h2 className="section-title">
            Każdy detal{' '}
            <span
              style={{
                fontStyle: 'italic',
                background: 'linear-gradient(135deg, #3b82f6, #60a5fa)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              mówi sam za siebie
            </span>
          </h2>
        </div>

        {/* Masonry grid */}
        <div className="masonry-grid">
          {images.map((img, i) => (
            <GalleryItem key={i} {...img} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}

function GalleryItem({ label, file, ratio, index }) {
  const ref = useFadeIn();

  return (
    <div
      ref={ref}
      className="fade-in-section masonry-item"
      style={{
        border: '1px solid rgba(59,130,246,0.1)',
        transition: 'all 0.35s ease',
        position: 'relative',
        overflow: 'hidden',
        cursor: 'pointer',
        transitionDelay: `${index * 60}ms`,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = 'rgba(59,130,246,0.35)';
        e.currentTarget.style.boxShadow = '0 20px 60px rgba(0,0,0,0.5), 0 0 30px rgba(59,130,246,0.1)';
        e.currentTarget.style.transform = 'scale(1.02)';
        const img = e.currentTarget.querySelector('.gallery-img');
        if (img) img.style.transform = 'scale(1.08)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = 'rgba(59,130,246,0.1)';
        e.currentTarget.style.boxShadow = 'none';
        e.currentTarget.style.transform = 'scale(1)';
        const img = e.currentTarget.querySelector('.gallery-img');
        if (img) img.style.transform = 'scale(1)';
      }}
    >
      <div className="gallery-img" style={{ transition: 'transform 0.5s ease' }}>
        <ImagePlaceholder label={`${label}&#10;(${file})`} aspectRatio={ratio} />
      </div>

      {/* Hover overlay */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(180deg, transparent 50%, rgba(5,10,26,0.8) 100%)',
          opacity: 0,
          transition: 'opacity 0.3s ease',
          display: 'flex',
          alignItems: 'flex-end',
          padding: 16,
          pointerEvents: 'none',
        }}
        className="gallery-overlay"
      />
    </div>
  );
}
